// Normalize API_URL by removing trailing slash to prevent double slashes in URLs
let API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
//const API_URL = "https://api.dev.travelrite.org";
API_URL = API_URL.replace(/\/+$/, "");

export const loginUrl = () => `${API_URL}/api/admin/login`;

export const notificationsUrl = (pageNo, pageSize, search, startDate, endDate) => {
  let url = `${API_URL}/api/admin/notifications?pageNo=${pageNo}&pageSize=${pageSize}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  return url;
};

export const pushNotificationUrl = () => `${API_URL}/api/push-notifications`;

export const forgotPasswordUrl = () => `${API_URL}/api/forget/password`;

export const verifyForgotTokenUrl = (verifyToken) =>
  `${API_URL}/api/verify/forget/password?forgetPasswordToken=${verifyToken}`;

export const resetPasswordUrl = () => `${API_URL}/api/reset/password`;

export const changePasswordUrl = () => `${API_URL}/api/change/passowrd`;

export const fetchUserListUrl = (rowsPerPage, page, sortDirection) =>
  `${API_URL}/api/list/user?pageNo=${page}&pageSize=${rowsPerPage}&sortDir=${sortDirection}`;

export const singleUserUrl = (userId) => `${API_URL}/api/user/${userId}`;

export const userActiveStatus = () => `${API_URL}/api/user/block`;

export const updateUserUrl = () => `${API_URL}/api/update/user`;

export const fetchFAQListUrl = () => `${API_URL}/api/get/faqs`;

export const addFAQUrl = () => `${API_URL}/api/add/faq`;

export const updateFAQUrl = () => `${API_URL}/api/update/faq`;

export const deleteFAQUrl = () => `${API_URL}/api/delete/faq`;

export const updateFAQPositionUrl = () => `${API_URL}/api/sequence/faq`;

export const topPerformersUrl = () => `${API_URL}/api/leaderboard`;

export const searchUserUrl = () => `${API_URL}/api/search?p=1&ps=20`;

export const dashboardChartUrl = () => `${API_URL}/api/track/chart`;

export const modeChartUrl = () => `${API_URL}/api/track/mode/chart`;

export const carOwnersUrl = () => `${API_URL}/api/type/vehicles`;

export const pointsChartUrl = () => `${API_URL}/api/track/mode/user`;

export const totalUsersAndTrees = () => `${API_URL}/api/users`;

export const todaysStats = () => `${API_URL}/api/dashboard/stats`;

export const fetchTripsUrl = (pageNo, pageSize, filters = {}) => {
  const { username, startsAt, endsAt, status, modeOfTravel, tripId } = filters;
  let url = `${API_URL}/api/trips?pageNo=${pageNo}&pageSize=${pageSize}`;
  if (username) url += `&username=${encodeURIComponent(username)}`;
  if (startsAt) url += `&starts_at=${startsAt}`;
  if (endsAt) url += `&ends_at=${endsAt}`;
  if (status) url += `&status=${status}`;
  if (modeOfTravel) url += `&modeOfTravel=${encodeURIComponent(modeOfTravel)}`;
  if (tripId) url += `&tripId=${tripId}`;
  return url;
};

export const verifyTripUrl = (tripId) =>
  `${API_URL}/api/trips/${tripId}/verify/admin`;

export const challengesUrl = (pageNo, pageSize, status, type, mode, repetition) => {
  let url = `${API_URL}/api/challenges?pageNo=${pageNo}&pageSize=${pageSize}`;
  if (status) url += `&status=${status}`;
  if (type) url += `&type=${type}`;
  if (mode) url += `&mode=${mode}`;
  if (repetition) url += `&repetition=${repetition}`;
  return url;
};

export const createChallengeUrl = () => `${API_URL}/api/challenges`;

export const singleChallengeUrl = (id) => `${API_URL}/api/challenges/${id}`;

export const s3PresignedUrl = (key, contentType) =>
  `${API_URL}/api/s3?key=${encodeURIComponent(key)}&contentType=${encodeURIComponent(contentType)}`;

export const userActivityDetailsUrl = (pageNo, pageSize, startDate, endDate) => {
  let url = `${API_URL}/api/user/challenges/details?pageNo=${pageNo}&pageSize=${pageSize}`;
  if (startDate) url += `&startDate=${startDate}`;
  if (endDate) url += `&endDate=${endDate}`;
  return url;
};

export const userActivityStatsUrl = (startDate, endDate) => {
  let url = `${API_URL}/api/user/challenges/stats`;
  const params = [];
  if (startDate) params.push(`startDate=${startDate}`);
  if (endDate) params.push(`endDate=${endDate}`);

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }
  return url;
};
